/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Reelplicate API
 * OpenAPI spec version: 1.0
 */

/**
 * Where the user is in first-run onboarding; COMPLETED once they finish.
 */
export type OnboardingStep = (typeof OnboardingStep)[keyof typeof OnboardingStep];

export const OnboardingStep = {
  WORKSPACE: 'WORKSPACE',
  BRAND: 'BRAND',
  COMPETITORS: 'COMPETITORS',
  PLATFORMS: 'PLATFORMS',
  PLAN: 'PLAN',
  TEAM: 'TEAM',
  SOURCE: 'SOURCE',
  COMPLETED: 'COMPLETED',
} as const;
